import ReactGA from "react-ga4";
import { IAppointmentAnalyticsParams, IQRScanAnalyticsParams } from "../dto/analyticsDto";

// const isProduction = process.env.NODE_ENV === "production";

/**
 * Initializes Google Analytics.
 * Should be called once when the application starts.
 */
export const initGA = () => {
    // Initialize GA only in production. You can remove this check if you want to track in development.
    if ((import.meta as any).env.VITE_GA_MEASUREMENT_ID) {
        ReactGA.initialize((import.meta as any).env.VITE_GA_MEASUREMENT_ID);
        console.log("GA Initialized ");
    } else {
        console.warn("GA Measurement ID not found. GA not initialized.");
    }
};

/**
 * Tracks a page view.
 * Should be called whenever a new route is accessed.
 * @param path - The path of the page to track (e.g., window.location.pathname + window.location.search)
 */
export const logPageView = (path: string) => {
    // if (isProduction) {
    // }
    ReactGA.send({ hitType: "pageview", page: path });
};

/**
 * This function logs when a user scans a doctor's QR code.
 * @param doctorId The doctor whose QR code was scanned
 */
export const logQrScanEvent = (params: IQRScanAnalyticsParams) => {
    const { doctorId, event } = params;
    const payload = {
        doctor_id: doctorId
    };
    console.log(`Logging analytics event: ${event} with payload:`, payload);
    ReactGA.event(event, payload);
};

/**
 * This function tracks appointment-related events such as booking, updating, and cancelling.
 * @param eventName enum value from AnalyticsEvent
 * @param user user object containing at least the
 */
export const logAppointmentEvent = (params: IAppointmentAnalyticsParams) => {
    const { appointment, action, channel } = params;
    const payload = {
        patient_id: appointment?.userInfo?.id,
        doctor_id: appointment?.doctorId,
        appointment_id: appointment?.id,
        channel: channel
    };
    console.log(`Logging analytics event: ${action} with payload:`, payload);
    ReactGA.event(action, payload);
};
